var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppHeaderDropdown",
    { attrs: { right: "", "no-caret": "" } },
    [
      _c("template", { slot: "header" }, [
        _c("i", {
          staticClass: "fa fa-user-circle-o",
          staticStyle: { "font-size": "1.6em" },
        }),
      ]),
      _c(
        "template",
        { slot: "dropdown" },
        [
          _c(
            "b-dropdown-header",
            {
              staticClass: "text-center",
              attrs: { boundary: "viewport", tag: "div" },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("message.connected_as")) + "\n      "
              ),
              _c("strong", [_vm._v(_vm._s(_vm.user))]),
            ]
          ),
          _vm.canUpdateProfile()
            ? _c(
                "b-dropdown-item",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.profileEditModal",
                      modifiers: { profileEditModal: true },
                    },
                  ],
                },
                [
                  _c("i", { staticClass: "fa fa-user text-primary" }),
                  _vm._v("\n      " + _vm._s(_vm.$t("message.profile_update"))),
                ]
              )
            : _vm._e(),
          _vm.canChangePassword()
            ? _c("b-dropdown-item", { attrs: { to: "/change-password" } }, [
                _c("i", { staticClass: "fa fa-key text-primary" }),
                _vm._v("\n      " + _vm._s(_vm.$t("message.change_password"))),
              ])
            : _vm._e(),
          _vm.canUpdateProfile() || _vm.canChangePassword()
            ? _c("b-dropdown-divider")
            : _vm._e(),
          _c(
            "b-dropdown-form",
            { staticClass: "pl-2 pr-2", attrs: { id: "locale-picker-form" } },
            [_c("LocalePicker")],
            1
          ),
          _c("b-dropdown-divider"),
          _c("b-dropdown-item", { on: { click: _vm.logout } }, [
            _c("i", { staticClass: "fa fa-sign-out text-primary" }),
            _vm._v("\n      " + _vm._s(_vm.$t("message.logout"))),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }